export const ENVIRONMENT = {
  BETA: 'beta',
  DEVELOPMENT: 'development',
  LOCAL: 'local',
  PRODUCTION: 'production',
  STAGING: 'staging',
  TEST: 'test',
} as const;

export type Environment = (typeof ENVIRONMENT)[keyof typeof ENVIRONMENT];

export const API_NAME = [
  'BETA',
  'DEV',
  'LOCAL',
  'PROD',
  'STAGING',
  'TEST',
] as const;
export type ApiName = (typeof API_NAME)[number];

export type EnvironmentName = ApiName;
